module.exports = __webpack_public_path__ + "img/worksbot_img19112536.30bd7b6c.jpg";